import { faqItems } from '@/mocks/homeData';
import { useState } from 'react';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number>(1);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
              <i className="ri-question-answer-line"></i>
              答疑解惑
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              常见问答
            </h2>
            <p className="text-sm text-foreground-500 mt-2">关于51吃瓜爆料网的常见问题解答</p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item) => (
              <div
                key={item.id}
                className="border border-background-200 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => setOpenId(openId === item.id ? 0 : item.id)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left hover:bg-background-100 transition-colors cursor-pointer"
                >
                  <h3 className="font-sans font-semibold text-sm md:text-base text-foreground-900 pr-4">
                    {item.question}
                  </h3>
                  <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all ${
                    openId === item.id
                      ? 'bg-primary-500 text-background-50 rotate-180'
                      : 'bg-background-100 text-foreground-500'
                  }`}>
                    <i className="ri-arrow-down-s-line"></i>
                  </div>
                </button>
                {openId === item.id && (
                  <div className="px-5 pb-5">
                    <div className="pt-1 border-t border-background-200">
                      <p className="text-sm text-foreground-600 leading-relaxed pt-4">
                        {item.answer}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}